/* global React */
// Shared SVG icons + small UI pieces for CRMaps app

const Icon = {
  search: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" />
    </svg>
  ),
  layers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m12 2 9 5-9 5-9-5z" /><path d="m3 12 9 5 9-5" /><path d="m3 17 9 5 9-5" />
    </svg>
  ),
  locate: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
  ),
  minus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M5 12h14"/></svg>
  ),
  back: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m15 18-6-6 6-6"/>
    </svg>
  ),
  share: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 16V4"/><path d="m8 8 4-4 4 4"/><path d="M20 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4"/>
    </svg>
  ),
  heart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
    </svg>
  ),
  filter: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 6h18M7 12h10M10 18h4"/>
    </svg>
  ),
  chevDown: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
  ),
  chevRight: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 6 6 6-6 6"/></svg>
  ),
  pin: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C7.58 2 4 5.58 4 10c0 5.5 8 12 8 12s8-6.5 8-12c0-4.42-3.58-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/></svg>
  ),
  mail: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>
    </svg>
  ),
  phone: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z"/>
    </svg>
  ),
  globe: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a13 13 0 0 1 0 18 13 13 0 0 1 0-18z"/>
    </svg>
  ),
  star: (
    <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2 14.5 9 22 9.27l-5.81 4.62L18 22l-6-3.6L6 22l1.81-8.11L2 9.27 9.5 9z"/></svg>
  ),
  sun: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M5 5l1.4 1.4M17.6 17.6 19 19M2 12h2M20 12h2M5 19l1.4-1.4M17.6 6.4 19 5"/>
    </svg>
  ),
  moon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
    </svg>
  ),
  arrow: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14"/><path d="m13 6 6 6-6 6"/>
    </svg>
  ),
  wind: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.6 4.6A2 2 0 1 1 11 8H2"/><path d="M12.6 19.4A2 2 0 1 0 14 16H2"/><path d="M17.5 8a2.5 2.5 0 1 1 2 4H2"/>
    </svg>
  ),
};

// iOS-style status bar
function StatusBar({ darkText }) {
  return (
    <div className={"ios-statusbar" + (darkText ? " dark-text" : "")}>
      <span style={{ fontWeight: 700 }}>9:41</span>
      <span className="right">
        {/* signal */}
        <svg width="17" height="11"><path d="M1 8h3v3H1zM5 6h3v5H5zM9 4h3v7H9zM13 1h3v10h-3z"/></svg>
        {/* wifi */}
        <svg width="16" height="11"><path d="M8 11l-1.5-1.5a2 2 0 013 0L8 11zM2 5l1.4 1.4a6 6 0 019.2 0L14 5a8 8 0 00-12 0zM-.5 2L1 3.5a10 10 0 0114 0L16.5 2a12 12 0 00-17 0z" transform="translate(0,0)"/></svg>
        {/* battery */}
        <svg width="26" height="12"><rect x="0.5" y="0.5" width="22" height="11" rx="3" fill="none" stroke="currentColor"/><rect x="2" y="2" width="19" height="8" rx="1.5"/><rect x="23" y="4" width="2" height="4" rx="1"/></svg>
      </span>
    </div>
  );
}

// Action button used inside hotspot panel
function ActionBtn({ kind, value, primary, children, onTrack, lang }) {
  const PNG_ICONS = {
    phone: "phone-icon.png",
    whatsapp: "whatsapp-icon.png",
    website: "web-icon.png",
    waze: "waze-icon.png",
    gmaps: "Google-icon.png",
    facebook: "facebook-icon.png",
    instagram: "instagram-icon.png",
    tripadvisor: "tripadvisor-icon.png",
  };
  const LABELS = {
    en: {
      phone: "Call", whatsapp: "WhatsApp", email: "Email",
      website: "Website", waze: "Waze", gmaps: "Google Map",
      facebook: "Facebook", instagram: "Instagram", tripadvisor: "Reviews",
    },
    es: {
      phone: "Llamar", whatsapp: "WhatsApp", email: "Email",
      website: "Web", waze: "Waze", gmaps: "Google Maps",
      facebook: "Facebook", instagram: "Instagram", tripadvisor: "Resenas",
    },
  };

  function buildHref(kind, value) {
    if (!value || value === true) return '#';
    const v = String(value).trim();
    switch (kind) {
      case 'phone':    return `tel:${v.replace(/\s/g, '')}`;
      case 'whatsapp': return `https://wa.me/${v.replace(/\D/g, '')}`;
      case 'email':    return `mailto:${v}`;
      case 'waze':
      case 'gmaps':    return v;
      default:         return /^https?:\/\//i.test(v) ? v : `https://${v}`;
    }
  }

  const href = buildHref(kind, value);
  const isExternal = /^https?:\/\//i.test(href);
  const usePng = PNG_ICONS[kind];

  return (
    <a
      className={"hp-action" + (primary ? " is-primary" : "")}
      data-kind={kind}
      href={href}
      target={isExternal ? "_blank" : "_self"}
      rel={isExternal ? "noopener noreferrer" : undefined}
      onClick={onTrack || undefined}
    >
      {usePng ? (
        <img src={`${window.CRMAPS_ASSET_BASE || ''}assets/icons/${usePng}`} alt="" />
      ) : (
        <span className="ha-glyph">{children || (kind === "email" ? Icon.mail : Icon.phone)}</span>
      )}
      <span>{LABELS[lang]?.[kind] || LABELS.en[kind] || kind}</span>
    </a>
  );
}

Object.assign(window, { Icon, StatusBar, ActionBtn });
